// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"acd99931","455":"1e60d3d1"}[chunkId] + ".chunk.js";
};